import { render } from "./xygk.vue?vue&type=template&id=344a7c5b&scoped=true"
const script = {}

import "./xygk.vue?vue&type=style&index=0&id=344a7c5b&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344a7c5b"]])

export default __exports__